import { useMemo } from "react";
import { useNotification } from "../../../../hooks/useNotification";
import { useUpdateShipmentStatusMutation } from "../../../../store/apiSlice/shipmentApiSlice";
import { componentWithCondition } from "../../../newLayout/page/components/hoc/componentWithConditionCheck";

const ShipmentV1Action = ({ selectedOrderId, setSelectedOrder, selectedOrderFromListview }) => {
  const notify = useNotification();
  const [updateShipmentStatus, { isLoading }] = useUpdateShipmentStatusMutation();

  const isSingleSelection = selectedOrderId.length === 1;
  const hasSelection = selectedOrderId.length > 0;

  const canBook = useMemo(() => {
    if (!isSingleSelection) return false;
    const status = String(
      selectedOrderFromListview[0]?.status?.id || 
      selectedOrderFromListview[0]?.status || 
      ""
    ).toLowerCase();
    return status === "created";
  }, [isSingleSelection, selectedOrderFromListview]);

  const handleBook = async () => {
    if (!isSingleSelection) return;
    const id = selectedOrderId[0];
    try {
      await updateShipmentStatus({ id, status_id: "booked" }).unwrap();
      notify({
        type: "success",
        message: "Shipment booked successfully.",
      });
      setSelectedOrder([]);
    } catch (error) {
      notify({
        type: "error",
        message: error?.data?.detail || "Failed to book shipment.",
      });
    }
  };

  return (
    <>
      <li className={`tableButton ${canBook && !isLoading ? "activeState" : "disableState"}`}>
        <button
          onClick={handleBook}
          disabled={!canBook || isLoading}
          title={
            !canBook && hasSelection
              ? isSingleSelection
                ? "Only allowed for shipments in CREATED status"
                : "Only one shipment can be booked at a time"
              : ""
          }
        >
          Book
        </button>
      </li>
    </>
  );
};

export const ShipmentV1ActionWithCheck = componentWithCondition(ShipmentV1Action);
